import { Collapse as AntdCollapse } from 'antd';
import {
  CollapseProps as AntdCollapseProps,
  CollapsePanelProps as AntdCollapsePanelProps,
} from 'antd/lib/collapse';

export type CollapseProps = AntdCollapseProps;
export type CollapsePanelProps = AntdCollapsePanelProps;

export const Collapse = AntdCollapse;

export default Collapse;
